/**
 * Run a function only once after 'wait' milliseconds. How to use: see unit tests
 * @param {Function} func Function to be used
 * @param {number} wait Time in ms to wait before running the function
 * @param immediate
 * @returns {Function}
 */
export function debounce(func, wait, immediate) {
    let timeout;
    return function() {
        const args = arguments;
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            timeout = null;
            !immediate && func.apply(null, args);
        }, wait);
        /* istanbul ignore if */
        if(callNow) {
            func.apply(null, args);
        }
    };
}



// WEBPACK FOOTER //
// /src/common/matchMedia/utils.js